import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {OrderActionDisplaySearchModel} from "../order-action-display-search.model";
import {OrderActionDisplayEntityModel} from "../order-action-display-entity.model";

@Component({
    selector: "wbo-order-action-display-search-page",
    templateUrl: "./order-action-display-search-page.component.html",
    providers: [
        provideSearchModel(OrderActionDisplaySearchModel),
        provideEntityModel(OrderActionDisplayEntityModel)
    ]
})
export class OrderActionDisplaySearchPageComponent extends AbstractSearchPage {
}
